import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'antd'
import PropTypes from 'prop-types'
import loSto from '../../config/loSto'

// Socket
import { sendSpeechConfig } from '../../ws/stream'

// Lodash
import _map from 'lodash/map'
import _get from 'lodash/get'

// Constants
import { MODAL_WIDTH, TITLE, CASE_TYPES } from './constants/general'
import OPTIONS from './constants/options'
import { ROUTES, isAmwellTheme } from '../../lib'
import { OPEN_LIST, OPEN_SCHEDULE, OPEN_SETTINGS_MODAL, OPEN_NOTE_TYPE_MODAL, OPEN_WHAT_CAN_I_SAY_MODAL, CLOSE_MODAL } from '../../constants/pubSub.events'

// Utils
import { History } from '../../config'
import pubSub from '../../lib/util/pubSub'

// Styles
import 'antd/lib/button/style/index.css'
import 'antd/lib/modal/style/index.css'
import styles from './whatCanISayModal.module.scss'

const renderFooter = (onclick) => {
  return (
    <Button
      className={styles.helpCenterButton}
      shape='round'
      size='large'
      onClick={onclick}
    >
      Go to Help Center
    </Button>
  )
}

const renderOption = (option, index) => {
  return <div className={styles.option} key={index}>{option}</div>
}
const WhatCanISayModal = (props) => {
  const pathName = _get(props, 'history.location.pathname')
  const [visible, setVisibility] = useState(false)
  const [caseType, setCaseType] = useState(CASE_TYPES.GENERAL)
  const isAmwell = isAmwellTheme()

  useEffect(() => {
    const whatCanISaySubscription = pubSub.subscribe(OPEN_WHAT_CAN_I_SAY_MODAL, () => {
      setVisibility(true)
      const openModalsList = loSto.get('OPEN_MODALS') || []
      openModalsList.push('whatCanISay')
      loSto.set('OPEN_MODALS', openModalsList)
    })

    const settingsModalSubscription = pubSub.subscribe(OPEN_SETTINGS_MODAL, () => {
      closeModal()
    })
    const scheduleSubscription = pubSub.subscribe(OPEN_SCHEDULE, () => {
      closeModal()
    })
    const listSubscription = pubSub.subscribe(OPEN_LIST, () => {
      closeModal()
    })
    const noteTypeModalSubscription = pubSub.subscribe(OPEN_NOTE_TYPE_MODAL, () => {
      closeModal()
    })

    const goBackSubscription = pubSub.subscribe(CLOSE_MODAL, () => {
      closeModal()
    })

    return () => {
      whatCanISaySubscription.unsubscribe()
      settingsModalSubscription.unsubscribe()
      noteTypeModalSubscription.unsubscribe()
      scheduleSubscription.unsubscribe()
      listSubscription.unsubscribe()
      goBackSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    closeModal()
  }, [pathName])

  useEffect(() => {
    if (isAmwell) {
      setCaseType(CASE_TYPES.AMWELL)
    } else if (pathName.includes(ROUTES.NOTE)) {
      setCaseType(CASE_TYPES.NOTE)
    } else {
      setCaseType(CASE_TYPES.GENERAL)
    }
  }, [pathName])

  const closeModal = () => {
    removeModalFromOpenModalsList()
    setVisibility(false)
  }

  const removeModalFromOpenModalsList = () => {
    const openModalsList = loSto.get('OPEN_MODALS')
    const whatCanISayIndex = openModalsList ? openModalsList.indexOf('whatCanISay') : null
    if (whatCanISayIndex || whatCanISayIndex === 0) {
      openModalsList.splice(whatCanISayIndex, 1)
      loSto.set('OPEN_MODALS', openModalsList)
    }
    sendSpeechConfig("Modal was closed");
  }

  const redirectToHelpCenter = () => {
    setVisibility(false)
    History.push(ROUTES.HELP)
  }

  if (isAmwell) {
    return (
      <Modal
        width={MODAL_WIDTH}
        closable={false}
        visible={visible}
        footer={null}
        className={styles.amwellContainer}
        onCancel={closeModal}
      >
        <div className={styles.title}>{TITLE}</div>
        <div className={styles.prefix}>You can also say "Suki...</div>
        <div className={styles.options}>
          {_map(OPTIONS[caseType], renderOption)}
        </div>
      </Modal>
    )
  }

  return (
    <Modal
      width={MODAL_WIDTH}
      title={TITLE}
      closable={false}
      visible={visible}
      footer={renderFooter(redirectToHelpCenter)}
      className={styles.container}
      onCancel={closeModal}
    >
      <div className={styles.prefix}>"Suki...</div>
      <div className={styles.options}>{_map(OPTIONS[caseType], renderOption)}</div>
    </Modal>
  )
}

WhatCanISayModal.propTypes = {
  history: PropTypes.object.isRequired
}

WhatCanISayModal.defaultProps = {}

export default WhatCanISayModal
